import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import SignInContainer from "../containers/SignInContainer";

const SignInPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <SignInContainer />
    </UnderMaintenanceOrChildren>
  );
};

export default SignInPage;
